import { useTranslation } from 'react-i18next';
import { Grid, Paper } from '@mui/material';
import MainContentHeader from 'src/shared/components/atoms/mainContentHeader';
import GridWrapper from 'src/shared/components/organisms/gridWrapper';
import ConsoleHelper from 'src/shared/functions/consoleHelper';
import { useState, useMemo, useEffect } from 'react';
import { useLocalStorage } from 'src/shared/hooks/useLocalStorage';
import { LocalStorageKeys } from 'src/shared/models/enums/localStorageKeys.enum';
import { useIsMounted } from 'src/shared/hooks/useIsMounted';
import { PageFilterSection } from 'src/shared/components/organisms/pageFilterSection';
import SearchField from 'src/shared/components/form/searchField';
import { MyExportsDataGrid } from '../components/myExportsDataGrid';
import { ExportFileSearchFilter } from '../models/exportFilterSearchFilter';

export const MyExportsPage = () => {
  const { t } = useTranslation(['file']);
  const isMounted = useIsMounted();
  const [tempSearchString, setTempSearchString] = useState<string | undefined>(undefined);
  const [searchInitialized, setSearchInitialized] = useState<boolean>(false);
  const [exportFileSearchFilter, setExportFileSearchFilter] = useLocalStorage(LocalStorageKeys.ExportFileSearchFilter, {
    sortCol: 'id',
    sortDir: 'desc',
    pageIndex: 0,
    pageSize: 25,
  } as ExportFileSearchFilter);

  const searchFilter: ExportFileSearchFilter = useMemo(() => {
    return {
      filter: exportFileSearchFilter?.filter,
      pageSize: exportFileSearchFilter?.pageSize,
      pageIndex: exportFileSearchFilter?.pageIndex,
      sortCol: exportFileSearchFilter?.sortCol,
      sortDir: exportFileSearchFilter?.sortDir,
    } as ExportFileSearchFilter;
  }, [
    exportFileSearchFilter?.filter,
    exportFileSearchFilter?.pageIndex,
    exportFileSearchFilter?.pageSize,
    exportFileSearchFilter?.sortCol,
    exportFileSearchFilter?.sortDir,
  ]);

  useEffect(() => {
    if (isMounted() && searchInitialized) {
      if (tempSearchString === '') {
        setExportFileSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
      if (tempSearchString && tempSearchString.length >= 2) {
        setExportFileSearchFilter((prev) => ({ ...prev, ...{ filter: tempSearchString, pageIndex: 0 } }));
      } else {
        setExportFileSearchFilter((prev) => ({ ...prev, ...{ filter: '', pageIndex: 0 } }));
      }
    }
  }, [isMounted, searchInitialized, setExportFileSearchFilter, tempSearchString]);

  return (
    <GridWrapper>
      <Grid item xs={12} md={4}>
        <MainContentHeader title={t('file:myExports.pageHeader')} />
      </Grid>
      <Grid item xs={12}>
        <Paper>
          <PageFilterSection
            leftContent={
              <SearchField
                initialValue={searchFilter.filter || ''}
                onSearch={(newSearchString) => {
                  setSearchInitialized(true);
                  setTempSearchString(newSearchString);
                }}
              />
            }
          />
          <MyExportsDataGrid
            loadingCallback={(x) => ConsoleHelper.log(x)}
            searchFilter={searchFilter}
            searchFilterCallback={(newFilter) =>
              setExportFileSearchFilter((prev) => ({
                ...prev,
                ...newFilter,
              }))
            }
          />
        </Paper>
      </Grid>
    </GridWrapper>
  );
};
